import {DataContainer, Feature, FeatureStatus, submitEvent, submitMerge, submitMiniAction} from '@otto-ec/tracking-bct';
import {PictureTextType, TRACKING_PROMO_TYPE} from "./types";
import PictureTextElementTile from "./picture_text_element_tile";

export default class GenericTrackingService {
    sendLoadedTracking(featureOrder: number, featureIndex: number, parentTrackingId: string, widgetTiles: PictureTextElementTile[], masFeatureTrackingLabels: DataContainer, moduleType: PictureTextType) {
        const trackingFeatures = [
            this.createWidgetFeature(featureOrder, featureIndex, parentTrackingId, widgetTiles.length, "loaded", masFeatureTrackingLabels, moduleType),
            ...widgetTiles.map(((widgetTile: PictureTextElementTile) => {
                return this.createWidgetTileFeature(widgetTile, parentTrackingId, "loaded")
            }))
        ];
        submitMerge({}, trackingFeatures);
    }

    sendClickTrackingEvent(featureOrder: number, featureIndex: number, parentFeatureId: string, widgetTile: PictureTextElementTile, filledSlots: number, masFeatureTrackingLabels: DataContainer, moduleType: PictureTextType) {
        const trackingFeatures = [
            this.createWidgetFeature(featureOrder, featureIndex, parentFeatureId, filledSlots, "clicked", masFeatureTrackingLabels, moduleType),
            this.createWidgetTileFeature(widgetTile, parentFeatureId, "clicked")
        ]
        submitEvent({}, {name: "open", features: trackingFeatures});
    }

    sendScrollTrackingEvent(parentFeatureId: string, featureIds: string[]) {
        const parentFeature = {'featureId': parentFeatureId}
        const tileFeatures = featureIds.map(featureId => {
            return {'featureId': featureId}
        })
        submitMiniAction([parentFeature, ...tileFeatures]);
    }

    createWidgetFeature(featureOrder: number, featureIndex: number, featureId: string, filledSlots: number, status: FeatureStatus, masFeatureTrackingLabels: DataContainer, moduleType: PictureTextType): Feature {
        const labels = {
            promo_Feature: ["true"],
            promo_FilledSlots: [(filledSlots).toString()],
            promo_FeatureNumber: [(featureIndex + 1).toString()],
            promo_TileType: [moduleType]
        };
        const mergedLabels = {
            ...labels,
            ...masFeatureTrackingLabels
        }
        return {
            id: featureId,
            name: TRACKING_PROMO_TYPE,
            position: featureOrder,
            status: status,
            labels: mergedLabels
        }
    }

    createWidgetTileFeature(widgetTile: PictureTextElementTile, parentFeatureId: string, status: FeatureStatus): Feature {
        return {
            id: widgetTile.id,
            parentId: parentFeatureId,
            name: `${TRACKING_PROMO_TYPE}-Tile`,
            position: widgetTile.position,
            status: status,
            labels: widgetTile.labels
        };
    }
}
